import { message } from 'antd'
import { useReducer, useContext, useCallback } from 'react'
import { flushSync } from 'react-dom';
import { AuthContext } from 'shared/context/auth-context'
import getBaseUrl from 'shared/utils/getBaseUrl';
import useHandleUnauthorized from 'shared/hooks/unauthorized-hook';

const initialState = {
  status: 'idle',
  responseData: null,
  errorMessage: null,
  requestIdentifier: null,
  responseMessage: null,
  loading: null
}

function httpReducer(currentHttpState, action) {
  switch (action.type) {
    case 'START': {
      return {
        ...currentHttpState,
        status: 'pending',
        loading: true
      }
    }
    case 'RESOLVE': {
      return {
        status: 'resolved',
        responseData: action.responseData,
        errorMessage: null,
        requestIdentifier: action.requestIdentifier,
        responseMessage: action.responseMessage,
        loading: false
      }
    }
    case 'REJECT': {
      return {
        status: 'rejected',
        responseData: action.responseData,
        errorMessage: action.errorMessage,
        requestIdentifier: action.requestIdentifier,
        responseMessage: null,
        loading: false
      }
    }
    default:
      throw new Error(`Unsupported type: ${action.type}`)
  }
}

function useHttpClient() {
  const [state, dispatch] = useReducer(httpReducer, initialState);
  const { token } = useContext(AuthContext);
  const handleUnauthorized = useHandleUnauthorized();

  const sendRequest = useCallback(async ({ endpoint, method, data }, requestIdentifier, responseMessage, errorMessage) => {
    

    const fetchBody = data ? JSON.stringify(data) : null;
    dispatch({ type: 'START' })
    window
      .fetch(
        getBaseUrl() + endpoint, {
        method,
        body: fetchBody,
        headers: {
          'Authorization': `Bearer ${token}`,
          'content-type': 'application/json',
          'Accept': 'application/json'
        },
      })
      .then(async response => {
        if (response.status === 401) { handleUnauthorized(); return; }
        if (response.status === 204) {
          flushSync(() => {
            dispatch({ type: 'RESOLVE', responseData: null, requestIdentifier, responseMessage })
          });
          return
        }
        const responseData = await response.json()
        if (response && response.ok) {
          flushSync(() => {
            dispatch({ type: 'RESOLVE', responseData, requestIdentifier, responseMessage })
          });
        } else {
          flushSync(() => {
            dispatch({ type: 'REJECT', responseData, requestIdentifier, errorMessage })
          });
          const keys = Object.keys(responseData)
          const messages = Object.values(responseData)
          messages.forEach((error, i) => { message.error(`${keys[i]} : ${error}`) });
        }
      }).catch(() => { message.error('Πρόβλημα με το δίκτυο', [5]); message.info('Παρακαλώ Δοκιμάστε αργότερα', [3]); })
  }, [token, handleUnauthorized])

  return {
    sendRequest,
    responseData: state.responseData,
    errorMessage: state.errorMessage,
    status: state.status,
    requestIdentifier: state.requestIdentifier,
    responseMessage: state.responseMessage,
    loading: state.loading
  }
}

export default useHttpClient;